import PropTypes from 'prop-types'
import React, {useEffect} from 'react'
import useAsync from '../../commerce-api/hooks/useAsync'
import Fanreel from '../../components/fanreel'
import useCachedProducts from '../../hooks/use-cached-products'
import {capitalize} from '../../utils/utils'

/**
 * Display Fanreel Component
 *
 * @param {string} pid - productId
 * @param {string} category - category
 * @param {string} headline - Headlinetext
 * @param {string} color - color of Headline
 * @param {string} dataSourceId - dataSourceId
 * @param {string} headlineAlignment - left or center alignment of Headline
 *
 * @example
 *   <pwa-widget-productinfos pid="1001" headline="Tripp Trapp® Chair in social" color="Pink" dataSourceId="yPTzASKbwXstIPxt" headlineAlignment="left">
 *     $include(...)$
 *   </pwa-widget-productinfos>
 */
const WidgetFanreel = ({pid, category, headline, color, dataSourceId, headlineAlignment}) => {
    const getCachedProducts = useCachedProducts()
    const {data, execute, reset} = useAsync(getCachedProducts)
    const product = data?.data[0]
    useEffect(() => {
        if (pid) {
            execute({
                parameters: {
                    ids: [pid],
                    allImages: true
                }
            })
        }

        // clear products if no longer allowed to load or item changes
        return () => {
            reset()
        }
    }, [execute, pid, reset])

    if (!pid && !category) {
        console.error(`No product ID or category provided`)
        return null
    }

    return (
        <Fanreel
            product={product}
            category={category}
            headline={headline}
            dataSourceId={dataSourceId}
            variant="widget"
            headlineHtmlProps={{
                textAlign: headlineAlignment || 'left',
                color: 'stokke' + capitalize(color) + '.dark'
            }}
        />
    )
}

WidgetFanreel.propTypes = {
    pid: PropTypes.string,
    category: PropTypes.string,
    headline: PropTypes.string,
    color: PropTypes.string,
    dataSourceId: PropTypes.string,
    headlineAlignment: PropTypes.string
}

export default WidgetFanreel
